import React from 'react';
import styled from 'styled-components';
import { SPACING } from '@govuk-react/constants';
import { asAnchor } from '@govuk-react/hoc';
import {
    Main,
    GridRow,
    GridCol,
    LeadParagraph,
    Paragraph,
    ListNavigation,
    Header
} from 'govuk-react';

const AnchorTag = asAnchor('a');

const ContentItem = styled('div')({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_4,
    borderTop: 'solid 1px #bfc1c3'
});

const RelatedContent = styled('div')({
    borderTop: '2px solid #005ea5',
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_4
});


const Introduction = styled('div')({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});



const ExampleOnePage = () => (
    <Main>
        <GridRow>
            <GridCol columnTwoThirds>
                <Introduction>
                    <Header level={1}>Layout 1</Header>
                    <LeadParagraph>
                        Phasellus vel bibendum elit. Aenean id nisi sit amet metus porta pulvinar quis at lorem. Curabitur quis vehicula erat. Nam rutrum efficitur dolor eu rutrum.
                    </LeadParagraph>
                    <Paragraph>
                        Nulla tincidunt mauris metus, in dictum risus egestas eget. Mauris nec ipsum erat.
                    </Paragraph>
                </Introduction>
            </GridCol>
        </GridRow>
        <GridRow>
            <GridCol columnTwoThirds>
                <ContentItem>
                    <Header level={2}>Content item</Header>
                    <Paragraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                        ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                        culpa qui officia deserunt mollit anim id est laborum
                    </Paragraph>
                </ContentItem>
                <ContentItem>
                    <Header level={2}>Content item</Header>
                    <Paragraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                        ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                        culpa qui officia deserunt mollit anim id est laborum
                    </Paragraph>
                </ContentItem>
            </GridCol>
            <GridCol columnOneThird>
                <RelatedContent>
                    <Header level={4}>Related content</Header>
                    <ListNavigation listStyleType="none">
                        <AnchorTag href="https://example.com/link-a">
                            Another page
                        </AnchorTag>
                        <AnchorTag href="https://example.com/link-b">
                            Yet another page
                        </AnchorTag>
                    </ListNavigation>
                </RelatedContent>
                <ContentItem>
                    <Header level={4}>Related content</Header>
                    <Paragraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </Paragraph>
                </ContentItem>
            </GridCol>
        </GridRow>
    </Main>
);

export default ExampleOnePage;
